/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BigClock_Application_Queries_GetDeviceLogs_DeviceLogsPageDto } from '../models/BigClock_Application_Queries_GetDeviceLogs_DeviceLogsPageDto';
import type { BigClock_Domain_DeviceLogCategory } from '../models/BigClock_Domain_DeviceLogCategory';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class LogsService {
    /**
     * @param deviceId
     * @param pageSize
     * @param from
     * @param to
     * @param search
     * @param snapshotAt
     * @param beforeTime
     * @param beforeId
     * @param category
     * @param includeTotal
     * @returns BigClock_Application_Queries_GetDeviceLogs_DeviceLogsPageDto Success
     * @throws ApiError
     */
    public static getApiLogsPage(
        deviceId: string,
        pageSize: number = 100,
        from?: string,
        to?: string,
        search?: string,
        snapshotAt?: string,
        beforeTime?: string,
        beforeId?: string,
        category?: BigClock_Domain_DeviceLogCategory,
        includeTotal: boolean = true,
    ): CancelablePromise<BigClock_Application_Queries_GetDeviceLogs_DeviceLogsPageDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Logs/{deviceId}/page',
            path: {
                'deviceId': deviceId,
            },
            query: {
                'pageSize': pageSize,
                'from': from,
                'to': to,
                'search': search,
                'snapshotAt': snapshotAt,
                'beforeTime': beforeTime,
                'beforeId': beforeId,
                'category': category,
                'includeTotal': includeTotal,
            },
        });
    }
    /**
     * @param deviceId
     * @returns any Success
     * @throws ApiError
     */
    public static getApiLogs(
        deviceId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Logs/{deviceId}',
            path: {
                'deviceId': deviceId,
            },
        });
    }
}
